export function addRowClickListener() {
  const onClick = (e: MouseEvent) => {
    const target = e.target as HTMLElement | null;
    if (!target) return;
    const button = target.closest('button[data-action="add-row"]') as HTMLButtonElement | null;
    if (!button) return;

    const tableId = button.getAttribute('data-table-id');
    const container = document.querySelector('.preview-form-content');
    if (!container || !tableId) return;
    const table = container.querySelector(`table[data-table-id="${CSS.escape(tableId)}"]`) as HTMLTableElement | null;
    if (!table) return;

    const tbody = table.querySelector('tbody');
    if (!tbody) return;

    const existingRows = Array.from(tbody.querySelectorAll('tr'));
    const firstRow = existingRows.find(r => r.querySelector('td')) || null;
    if (!firstRow) return;

    const nextSeqId = (colIdx: number): string | null => {
      const rows = Array.from(tbody.querySelectorAll('tr'));
      if (rows.length === 0) return null;
      const prevRow = rows[rows.length - 1];
      const prevTd = prevRow.querySelector(`td:nth-child(${colIdx + 1})`);
      if (!prevTd) return null;
      const prevEl = prevTd.querySelector('input, textarea') as (HTMLInputElement | HTMLTextAreaElement | null);
      const did = prevEl?.getAttribute('data-id') || '';
      if (!did) return null;

      const letterSeqRegex = /^(q\d{2})([a-z])_([a-z0-9_]+)$/i;
      const ml = did.match(letterSeqRegex);
      if (ml) {
        const base = ml[1];
        const letter = ml[2];
        const suffix = ml[3];
        const next = String.fromCharCode(letter.toLowerCase().charCodeAt(0) + 1);
        return `${base}${next}_${suffix}`;
      }
      const lastNumMatch = did.match(/^(.*?)(\d+)([^\d]*)$/);
      if (lastNumMatch) {
        const prefix = lastNumMatch[1];
        const numStr = lastNumMatch[2];
        const suffixTail = lastNumMatch[3];
        const num = parseInt(numStr, 10);
        if (isFinite(num)) {
          const nextNum = num + 1;
          return `${prefix}${nextNum}${suffixTail}`;
        }
      }
      return null;
    };

    const lastExisting = existingRows[existingRows.length - 1] || firstRow;
    const newTr = lastExisting.cloneNode(true) as HTMLTableRowElement;
    Array.from(newTr.querySelectorAll('td')).forEach((td, idx) => {
      const inputs = Array.from(td.querySelectorAll('input, textarea')) as (HTMLInputElement | HTMLTextAreaElement)[];
      inputs.forEach((el) => {
        const seqId = nextSeqId(idx);
        if (seqId) {
          el.setAttribute('data-id', seqId);
        }
        if (el instanceof HTMLInputElement) {
          if (el.type === 'checkbox') {
            el.checked = false;
          } else {
            el.value = '';
          }
        } else {
          el.value = '';
        }
      });
    });

    newTr.setAttribute('data-row-index', String(existingRows.length + 1));
    newTr.id = `${tableId}__row_${existingRows.length + 1}`;
    tbody.appendChild(newTr);
    const textInputs = Array.from(newTr.querySelectorAll('input[type="text"], textarea')) as (HTMLInputElement | HTMLTextAreaElement)[];
    const hasTextFields = textInputs.length > 0;
    const updateButtonDisabled = () => {
      const anyFilled = textInputs.some(el => (el instanceof HTMLInputElement ? el.value.trim().length > 0 : el.value.trim().length > 0));
      button.disabled = hasTextFields ? !anyFilled : false;
    };
    if (hasTextFields) {
      button.disabled = true;
      textInputs.forEach(el => {
        el.addEventListener('input', updateButtonDisabled);
        el.addEventListener('change', updateButtonDisabled);
      });
    } else {
      button.disabled = false;
    }
  };

  document.addEventListener('click', onClick);
  return () => document.removeEventListener('click', onClick);
}
